import React, { createContext, useEffect, useState } from "react";
import webSocketService from "./webSocketService";
import { useToken } from "../common/helper";
import { useSelector } from "react-redux";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const { token, getUserID, setUserId, getToken, setToken } = useToken();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const activeUserID = selectedUserID || getUserID();

  useEffect(() => {
    if (token && activeUserID) {
      const baseDomain = process.env.REACT_APP_WEB_SOCKETS ;
      const wsUrl = `${baseDomain}/chat/${activeUserID}/?token=${token}`;
      webSocketService?.connect(wsUrl);
    } else {
      setToken(getToken());
      setUserId(getUserID());
    }

    return () => {
      webSocketService.disconnect();
    };
  }, [token, activeUserID, isAuthenticated]);

  return (
    <WebSocketContext.Provider
      value={{ webSocketService, selectedUserID, setSelectedUserID }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => React.useContext(WebSocketContext);
